module.exports = __webpack_public_path__ + "static/img/seating-arrange.0183a95.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/seating-arrange.png
// module id = kg5i
// module chunks = 1